import { Component, ElementRef } from '@angular/core';

/**
 * @ignore
 */
@Component({
  selector: 'uex-card-subtitle',
  templateUrl: './subtitle.component.html'
})
export class CardSubtitleComponent {
  constructor(
    public elementRef: ElementRef
  ) { }
}

/**
 * @ignore
 */
@Component({
  selector: '[uex-card-subtitle]',
  template: '<ng-content></ng-content>',
  host: {
    class: 'uex-card-subtitle card-subtitle'
  }
})
export class CardHeadingSubtitleComponent {
  constructor() { }
}
